import React from "react";
import { Outlet } from "react-router-dom";
import { UserChatProvider } from "../contexts/user-chat-context";

export function UserLayout() {
  return (
    <UserChatProvider>
      <div
        data-testid="user-layout"
        className="w-full h-full flex flex-col min-h-0"
      >
        <Outlet />
      </div>
    </UserChatProvider>
  );
}
